
import {  faHouseLaptop ,  faBan } from "@fortawesome/free-solid-svg-icons";
import InfoIcon from './InfoIcon';
import { Link } from "react-router-dom";


export default function NotFound() {
    return <div className='rso-pages notfounded-container bg-warning m-0' >
        <InfoIcon icon={faBan} className='mb-5' style={{ fontSize: 200 }} title='404 not founded' withBubble={true} />

        <h1 style={{ fontWeight: 'bold', fontSize: 100 }} className='mb-2' >404</h1>
      
        <p style={{ fontSize: 20 }} >
             Page not found
        </p>
     
        <Link to='/' className="btn btn-secondary bgnt" ><InfoIcon icon={faHouseLaptop} size='xl' />Dashboard</Link>

    </div>


}
